class LocationService {

    /*@ngInject*/
    constructor($resource) {
        this.$resource = $resource;
    }

    typeAheadSearchForPostcode(postCode, resultsLimit) {

        var postCode = this.$resource('/trsonline/stores/public/suburbs/search', {}, {
            getPostCode: {
                method: 'GET',
                params: {query: postCode},
                isArray: true
            }
        });

        return postCode.getPostCode().$promise.then(
            function(response) {
                var results = response;

                results = Array.prototype.map.call(results, function(result) {
                    result.postCode = result.postCode || result.codeNumber;
                    delete result.codeNumber;
                    return result;
                }).slice(0, resultsLimit);

                return results;
            }
        );
    }
}

export default LocationService;


// WEBPACK FOOTER //
// ./src/app/services/location-service.js